import { Injectable } from '@angular/core';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUtils } from '@article/util/article-utils';
import { ProjectModel } from '@project/model/project.model';
import { Log } from '@shared/debug/log';
import { ProjectContentPresenter } from '@shared/presenter/project-content.presenter';
import { ArrayUtils } from '@shared/util/array-utils';
import { ConnectionAreaVO, MetaElementVO } from '@shared/vo/meta-element.vo';
import { ApplicationRefreshService } from '@services/application-refresh.service';

@Injectable({
  providedIn: 'root',
})
export class ReplaceArticleService {

  constructor(
    private projectModel: ProjectModel,
    private applicationRefreshService: ApplicationRefreshService,
    private projectContentPresenter: ProjectContentPresenter,
  ) {
  }

  public async replaceArticle(articleContainer: ArticleContainer, article: ArticleVO) {
    const oldArticle: ArticleVO = articleContainer.article;
    articleContainer.isParsed = false;
    articleContainer.updateArticle(article);
    articleContainer.disposeModel();
    if (articleContainer.articleUsage) {
      articleContainer.articleUsage.articleId = article.identity;
      articleContainer.articleUsage.articleVersion = article.version;
      if (ArrayUtils.isNotEmpty(articleContainer.articleUsage.metaElementUsages)) {
        if (ArrayUtils.isNotEmpty(article.metaElements)) {
          for (const connectionAreaUsageVO of ArticleUsageUtils.connectionAreaUsages(articleContainer.articleUsage)) {
            const oldMetaElementName: string = connectionAreaUsageVO.identity.metaElementName;
            const oldMetaElement: MetaElementVO = ArticleUtils.findMetaElementByName(oldArticle, oldMetaElementName);
            if (ConnectionInfoUtils.isRangeOnLineConnection(oldMetaElement)) {
              const oldRangeOnLineConnectionType: string = ConnectionInfoUtils.getRangeOnLineConnectionType(oldMetaElement);
              const connectionAreaVO: ConnectionAreaVO = ConnectionInfoUtils.findRangeOnLineConnectionByType(
                article.metaElements,
                oldRangeOnLineConnectionType,
              );
              if (!Log.assertExists(connectionAreaVO, 'connectionAreaVO')) {
                continue;
              }
              connectionAreaUsageVO.identity.metaElementName = connectionAreaVO.name;
              if (connectionAreaUsageVO.connection && connectionAreaUsageVO.connection.acceptingAreaId) {
                connectionAreaUsageVO.connection.acceptingAreaId.metaElementName = connectionAreaVO.name;
              }
              // update possible change in metaElementname in connected Articles
              for (const givingMetaElementUsageIdentityVO of connectionAreaUsageVO.connection.givingAreaIds) {
                const connectedArticleUsage: ArticleUsageVO = this.projectModel.getArticleUsage(givingMetaElementUsageIdentityVO.articleUsageId);
                if (connectedArticleUsage) {
                  for (const connectedAreaUsage of ArticleUsageUtils.connectionAreaUsages(connectedArticleUsage)) {
                    if (connectedAreaUsage.connection.acceptingAreaId.articleUsageId === articleContainer.articleUsage.id &&
                      connectedAreaUsage.connection.acceptingAreaId.metaElementName === oldMetaElementName) {
                      connectedAreaUsage.connection.acceptingAreaId.metaElementName = connectionAreaVO.name;
                    }
                  }
                }
              }
            } else {
              Log.error('Error while replacing article. A meta-element usage could not be translated to new article.');
            }
          }
        } else {
          articleContainer.articleUsage.metaElementUsages = [];
        }
      }
    }
    await this.applicationRefreshService.refreshProject();
    this.projectContentPresenter.articleReplaced(articleContainer);
  }
}
